import { create } from 'zustand';
import { ProfileRequest } from '../../types/Profile';
import { devtools, persist } from 'zustand/middleware';

type UserState = {
  user: ProfileRequest | null;
  setUser: (user: ProfileRequest) => void;
  clearUser: () => void;
};

const useUserStore = create<UserState>()(
  devtools(
    persist(
      (set) => ({
        user: null,
        setUser: (user: ProfileRequest) => set({ user }),
        clearUser: () => set({ user: null }),
      }),
      {
        name: 'current-user', // Unique name for the storage
      },
    ),
  ),
);
export default useUserStore;
